import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: /*@__PURE__*/_normalizeClass(`as-goals-scored`)
}
const _hoisted_2 = { class: "as-goals-scored__head" }
const _hoisted_3 = { class: "as-history" }
const _hoisted_4 = { class: "as-history-item" }
const _hoisted_5 = { class: "as-history-item__head" }
const _hoisted_6 = { class: "as-history-item__body" }
const _hoisted_7 = { class: "as-competition" }
const _hoisted_8 = { class: "as-competition__table" }
const _hoisted_9 = { class: "as-center a" }
const _hoisted_10 = { class: "as-center a" }

import { ref, computed } from "vue";
import IconWhistle from "~src/components/icons/foot_stats/IconWhistle.vue";
import type { IMatch } from "~src/interfaces";
import type { IFootyStats, ITeam, IStatsParent } from "~src/interfaces/footystats";
import { getClassForItem } from "~src/helpers/footystats";


const __default__ = {};

interface Props {
  match: IMatch;
  mode?: string;
  footyStats: IFootyStats | null;
  homeTeamInfo: ITeam | null;
  awayTeamInfo: ITeam | null;
}

interface IData {
  title: string;
  home: {
    value: number;
    _class: string;
  };
  away: {
    value: number;
    _class: string;
  };
  avg: {
    value: number;
    _class: string;
  };
  is_percent?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'WhistleList',
  props: {
    match: {},
    mode: { default: "as-win" },
    footyStats: {},
    homeTeamInfo: {},
    awayTeamInfo: {}
  },
  setup(__props: any) {

const props = __props;
const activeTab = ref("free-kick");
const setActiveTab = (tab: string) => {
  activeTab.value = tab;
};

const data = computed(() => {
  let _data: IData[] = [
    {
      title: "Trung bình trận đấu",
      home: {
        value: getValueWithMode("home", "freekicks_team_avg_overall", false),
        _class: getClassForItem(
          getValueWithMode("home", "freekicks_team_avg_overall", false)
        ),
      },
      away: {
        value: getValueWithMode("away", "freekicks_team_avg_overall", false),
        _class: getClassForItem(
          getValueWithMode("away", "freekicks_team_avg_overall", false)
        ),
      },
      avg: {
        value: calculatorAVG(
          getValueWithMode("home", "freekicks_team_avg_overall", false),
          getValueWithMode("away", "freekicks_team_avg_overall", false)
        ),
        _class: getClassForItem(
          calculatorAVG(
            getValueWithMode("home", "throwins_total_over425_overall", false),
            getValueWithMode("away", "throwins_total_over425_overall", false)
          )
        ),
      },
      is_percent: false,
    },
    {
      title: "Trên 20.5",
      home: {
        value: getValueWithMode("home", "freekicks_total_over205_overall", false),
        _class: getClassForItem(
          getValueWithMode("home", "freekicks_total_over205_overall", false)
        ),
      },
      away: {
        value: getValueWithMode("away", "freekicks_total_over205_overall", false),
        _class: getClassForItem(
          getValueWithMode("away", "freekicks_total_over205_overall", false)
        ),
      },
      avg: {
        value: calculatorAVG(
          getValueWithMode("home", "freekicks_total_over205_overall", false),
          getValueWithMode("away", "freekicks_total_over205_overall", false)
        ),
        _class: getClassForItem(
          calculatorAVG(
            getValueWithMode("home", "freekicks_total_over205_overall", false),
            getValueWithMode("away", "freekicks_total_over205_overall", false)
          )
        ),
      },
      is_percent: true,
    },
    {
      title: "Trên 21.5",
      home: {
        value: getValueWithMode("home", "freekicks_total_over215_overall", false),
        _class: getClassForItem(
          getValueWithMode("home", "freekicks_total_over215_overall", false)
        ),
      },
      away: {
        value: getValueWithMode("away", "freekicks_total_over215_overall", false),
        _class: getClassForItem(
          getValueWithMode("away", "freekicks_total_over215_overall", false)
        ),
      },
      avg: {
        value: calculatorAVG(
          getValueWithMode("home", "freekicks_total_over215_overall", false),
          getValueWithMode("away", "freekicks_total_over215_overall", false)
        ),
        _class: getClassForItem(
          calculatorAVG(
            getValueWithMode("home", "freekicks_total_over215_overall", false),
            getValueWithMode("away", "freekicks_total_over215_overall", false)
          )
        ),
      },
      is_percent: true,
    },
    {
      title: "Trên 22.5",
      home: {
        value: getValueWithMode("home", "freekicks_total_over225_overall", false),
        _class: getClassForItem(
          getValueWithMode("home", "freekicks_total_over225_overall", false)
        ),
      },
      away: {
        value: getValueWithMode("away", "freekicks_total_over225_overall", false),
        _class: getClassForItem(
          getValueWithMode("away", "freekicks_total_over225_overall", false)
        ),
      },
      avg: {
        value: calculatorAVG(
          getValueWithMode("home", "freekicks_total_over225_overall", false),
          getValueWithMode("away", "freekicks_total_over225_overall", false)
        ),
        _class: getClassForItem(
          calculatorAVG(
            getValueWithMode("home", "freekicks_total_over225_overall", false),
            getValueWithMode("away", "freekicks_total_over225_overall", false)
          )
        ),
      },
      is_percent: true,
    },
    {
      title: "Trên 23.5",
      home: {
        value: getValueWithMode("home", "freekicks_total_over235_overall", false),
        _class: getClassForItem(
          getValueWithMode("home", "freekicks_total_over235_overall", false)
        ),
      },
      away: {
        value: getValueWithMode("away", "freekicks_total_over235_overall", false),
        _class: getClassForItem(
          getValueWithMode("away", "freekicks_total_over235_overall", false)
        ),
      },
      avg: {
        value: calculatorAVG(
          getValueWithMode("home", "freekicks_total_over235_overall", false),
          getValueWithMode("away", "freekicks_total_over235_overall", false)
        ),
        _class: getClassForItem(
          calculatorAVG(
            getValueWithMode("home", "freekicks_total_over235_overall", false),
            getValueWithMode("away", "freekicks_total_over235_overall", false)
          )
        ),
      },
      is_percent: true,
    },
    {
      title: "Trên 24.5",
      home: {
        value: getValueWithMode("home", "freekicks_total_over245_overall", false),
        _class: getClassForItem(
          getValueWithMode("home", "freekicks_total_over245_overall", false)
        ),
      },
      away: {
        value: getValueWithMode("away", "freekicks_total_over245_overall", false),
        _class: getClassForItem(
          getValueWithMode("away", "freekicks_total_over245_overall", false)
        ),
      },
      avg: {
        value: calculatorAVG(
          getValueWithMode("home", "freekicks_total_over245_overall", false),
          getValueWithMode("away", "freekicks_total_over245_overall", false)
        ),
        _class: getClassForItem(
          calculatorAVG(
            getValueWithMode("home", "freekicks_total_over245_overall", false),
            getValueWithMode("away", "freekicks_total_over245_overall", false)
          )
        ),
      },
      is_percent: true,
    },
    {
      title: "Trên 25.5",
      home: {
        value: getValueWithMode("home", "freekicks_total_over255_overall", false),
        _class: getClassForItem(
          getValueWithMode("home", "freekicks_total_over255_overall", false)
        ),
      },
      away: {
        value: getValueWithMode("away", "freekicks_total_over255_overall", false),
        _class: getClassForItem(
          getValueWithMode("away", "freekicks_total_over255_overall", false)
        ),
      },
      avg: {
        value: calculatorAVG(
          getValueWithMode("home", "freekicks_total_over255_overall", false),
          getValueWithMode("away", "freekicks_total_over255_overall", false)
        ),
        _class: getClassForItem(
          calculatorAVG(
            getValueWithMode("home", "freekicks_total_over255_overall", false),
            getValueWithMode("away", "freekicks_total_over255_overall", false)
          )
        ),
      },
      is_percent: true,
    },
  ];

  if (activeTab.value === "kick") {
    _data = [
      {
        title: "Total Goal Kicks AVG",
        home: {
          value: getValueWithMode("home", "goal_kicks_total_avg_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "goal_kicks_total_avg_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "goal_kicks_total_avg_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "goal_kicks_total_avg_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "goal_kicks_total_avg_overall", false),
            getValueWithMode("away", "goal_kicks_total_avg_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "goal_kicks_total_avg_overall", false),
              getValueWithMode("away", "goal_kicks_total_avg_overall", false)
            )
          ),
        },
        is_percent: false,
      },
      {
        title: "GK Total 8.5+",
        home: {
          value: getValueWithMode("home", "goal_kicks_total_over85_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "goal_kicks_total_over85_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "goal_kicks_total_over85_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "goal_kicks_total_over85_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "goal_kicks_total_over85_overall", false),
            getValueWithMode("away", "goal_kicks_total_over85_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "goal_kicks_total_over85_overall", false),
              getValueWithMode("away", "goal_kicks_total_over85_overall", false)
            )
          ),
        },
        is_percent: true,
      },
      {
        title: "GK Total 9.5+",
        home: {
          value: getValueWithMode("home", "goal_kicks_total_over95_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "goal_kicks_total_over95_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "goal_kicks_total_over95_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "goal_kicks_total_over95_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "goal_kicks_total_over95_overall", false),
            getValueWithMode("away", "goal_kicks_total_over95_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "goal_kicks_total_over95_overall", false),
              getValueWithMode("away", "goal_kicks_total_over95_overall", false)
            )
          ),
        },
        is_percent: true,
      },
      {
        title: "GK Total 10.5+",
        home: {
          value: getValueWithMode("home", "goal_kicks_total_over105_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "goal_kicks_total_over105_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "goal_kicks_total_over105_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "goal_kicks_total_over105_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "goal_kicks_total_over105_overall", false),
            getValueWithMode("away", "goal_kicks_total_over105_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "goal_kicks_total_over105_overall", false),
              getValueWithMode("away", "goal_kicks_total_over105_overall", false)
            )
          ),
        },
        is_percent: true,
      },
      {
        title: "GK Total 115+",
        home: {
          value: getValueWithMode("home", "goal_kicks_total_over115_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "goal_kicks_total_over115_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "goal_kicks_total_over115_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "goal_kicks_total_over115_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "goal_kicks_total_over115_overall", false),
            getValueWithMode("away", "goal_kicks_total_over115_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "goal_kicks_total_over115_overall", false),
              getValueWithMode("away", "goal_kicks_total_over115_overall", false)
            )
          ),
        },
        is_percent: true,
      },
      {
        title: "GK Total 125+",
        home: {
          value: getValueWithMode("home", "goal_kicks_total_over125_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "goal_kicks_total_over125_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "goal_kicks_total_over125_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "goal_kicks_total_over125_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "goal_kicks_total_over125_overall", false),
            getValueWithMode("away", "goal_kicks_total_over125_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "goal_kicks_total_over125_overall", false),
              getValueWithMode("away", "goal_kicks_total_over125_overall", false)
            )
          ),
        },
        is_percent: true,
      },
      {
        title: "GK Total 135+",
        home: {
          value: getValueWithMode("home", "goal_kicks_total_over135_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "goal_kicks_total_over135_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "goal_kicks_total_over135_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "goal_kicks_total_over135_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "goal_kicks_total_over135_overall", false),
            getValueWithMode("away", "goal_kicks_total_over135_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "goal_kicks_total_over135_overall", false),
              getValueWithMode("away", "goal_kicks_total_over135_overall", false)
            )
          ),
        },
        is_percent: true,
      },
    ];
  }
  if (activeTab.value === "throw") {
    _data = [
      {
        title: "Total Throw-ins AVG",
        home: {
          value: getValueWithMode("home", "throwins_team_avg_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "throwins_team_avg_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "throwins_team_avg_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "throwins_team_avg_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "throwins_team_avg_overall", false),
            getValueWithMode("away", "throwins_team_avg_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "throwins_team_avg_overall", false),
              getValueWithMode("away", "throwins_team_avg_overall", false)
            )
          ),
        },
        is_percent: false,
      },
      {
        title: "Throw-ins Total 37.5+",
        home: {
          value: getValueWithMode("home", "throwins_total_over375_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "throwins_total_over375_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "throwins_total_over375_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "throwins_total_over375_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "throwins_total_over375_overall", false),
            getValueWithMode("away", "throwins_total_over375_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "throwins_total_over375_overall", false),
              getValueWithMode("away", "throwins_total_over375_overall", false)
            )
          ),
        },
        is_percent: true,
      },
      {
        title: "Throw-ins Total 38.5+",
        home: {
          value: getValueWithMode("home", "throwins_total_over385_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "throwins_total_over385_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "throwins_total_over385_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "throwins_total_over385_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "throwins_total_over385_overall", false),
            getValueWithMode("away", "throwins_total_over385_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "throwins_total_over385_overall", false),
              getValueWithMode("away", "throwins_total_over385_overall", false)
            )
          ),
        },
        is_percent: true,
      },
      {
        title: "Throw-ins Total 39.5+",
        home: {
          value: getValueWithMode("home", "throwins_total_over395_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "throwins_total_over395_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "throwins_total_over395_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "throwins_total_over395_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "throwins_total_over395_overall", false),
            getValueWithMode("away", "throwins_total_over395_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "throwins_total_over395_overall", false),
              getValueWithMode("away", "throwins_total_over395_overall", false)
            )
          ),
        },
        is_percent: true,
      },
      {
        title: "Throw-ins Total 40.5+",
        home: {
          value: getValueWithMode("home", "throwins_total_over405_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "throwins_total_over405_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "throwins_total_over405_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "throwins_total_over405_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "throwins_total_over405_overall", false),
            getValueWithMode("away", "throwins_total_over405_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "throwins_total_over405_overall", false),
              getValueWithMode("away", "throwins_total_over405_overall", false)
            )
          ),
        },
        is_percent: true,
      },
      {
        title: "Throw-ins Total 41.5+",
        home: {
          value: getValueWithMode("home", "throwins_total_over415_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "throwins_total_over415_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "throwins_total_over415_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "throwins_total_over415_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "throwins_total_over415_overall", false),
            getValueWithMode("away", "throwins_total_over415_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "throwins_total_over415_overall", false),
              getValueWithMode("away", "throwins_total_over415_overall", false)
            )
          ),
        },
        is_percent: true,
      },
      {
        title: "Throw-ins Total 42.5+",
        home: {
          value: getValueWithMode("home", "throwins_total_over425_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "throwins_total_over425_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "throwins_total_over425_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "throwins_total_over425_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "throwins_total_over425_overall", false),
            getValueWithMode("away", "throwins_total_over425_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "throwins_total_over425_overall", false),
              getValueWithMode("away", "throwins_total_over425_overall", false)
            )
          ),
        },
        is_percent: true,
      },
      {
        title: "Throw-ins Total 43.5+",
        home: {
          value: getValueWithMode("home", "throwins_total_over435_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "throwins_total_over435_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "throwins_total_over435_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "throwins_total_over435_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "throwins_total_over435_overall", false),
            getValueWithMode("away", "throwins_total_over435_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "throwins_total_over435_overall", false),
              getValueWithMode("away", "throwins_total_over435_overall", false)
            )
          ),
        },
        is_percent: true,
      },
      {
        title: "Throw-ins Total 44.5+",
        home: {
          value: getValueWithMode("home", "throwins_total_over445_overall", false),
          _class: getClassForItem(
            getValueWithMode("home", "throwins_total_over445_overall", false)
          ),
        },
        away: {
          value: getValueWithMode("away", "throwins_total_over445_overall", false),
          _class: getClassForItem(
            getValueWithMode("away", "throwins_total_over445_overall", false)
          ),
        },
        avg: {
          value: calculatorAVG(
            getValueWithMode("home", "throwins_total_over445_overall", false),
            getValueWithMode("away", "throwins_total_over445_overall", false)
          ),
          _class: getClassForItem(
            calculatorAVG(
              getValueWithMode("home", "throwins_total_over445_overall", false),
              getValueWithMode("away", "throwins_total_over445_overall", false)
            )
          ),
        },
        is_percent: true,
      },
    ];
  }
  console.log(_data)
  return _data;
});

const homeTeamLastX = computed<IStatsParent>(() => {
  return props.footyStats?.home_team_last_x ?? ({} as IStatsParent);
});

const awayTeamLastX = computed<IStatsParent>(() => {
  return props.footyStats?.away_team_last_x ?? ({} as IStatsParent);
});

const getValueWithMode = (team = "home", mode = "btts", is_stats = true) => {
  const __data: IStatsParent = team === "home" ? homeTeamLastX.value : awayTeamLastX.value;

  if (!__data || !__data.stats) {
    return 0;
  }

  const targetStats = is_stats ? __data?.stats : __data?.stats?.additional_info;

  if (targetStats && targetStats.hasOwnProperty(mode)) {
    return targetStats[mode] as number;
  }

  return 0;
};

const calculatorAVG = (home: number, away: number) => {
  const _avg = (home + away) / 2;

  return Math.round(_avg);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(IconWhistle),
      _cache[3] || (_cache[3] = _createElementVNode("span", null, " Đá phạt, Phát bóng và Ném biên ", -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["as-head-tab as-uppercase", {
              'as-active': activeTab.value === 'free-kick',
            }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (setActiveTab('free-kick')))
          }, " đá phạt trực tiếp ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["as-head-tab as-uppercase", {
              'as-active': activeTab.value === 'kick',
            }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (setActiveTab('kick')))
          }, " phát bóng từ cầu môn ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["as-head-tab as-uppercase", {
              'as-active': activeTab.value === 'throw',
            }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (setActiveTab('throw')))
          }, " ném biên ", 2)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _cache[4] || (_cache[4] = _createElementVNode("th", null, "Tổng số quả đá phạt", -1)),
                  _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.footyStats?.home_name), 1),
                  _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.footyStats?.away_name), 1),
                  _cache[5] || (_cache[5] = _createElementVNode("th", { class: "as-center a" }, "Trung bình", -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(item.title), 1),
                    _createElementVNode("td", {
                      class: _normalizeClass(`as-center ${item.home._class}`)
                    }, _toDisplayString(item.home.value) + _toDisplayString(item.is_percent ? "%" : ""), 3),
                    _createElementVNode("td", {
                      class: _normalizeClass(`as-center ${item.away._class}`)
                    }, _toDisplayString(item.away.value) + _toDisplayString(item.is_percent ? "%" : ""), 3),
                    _createElementVNode("td", {
                      class: _normalizeClass(`as-center ${item.avg._class}`)
                    }, _toDisplayString(item.avg.value) + _toDisplayString(item.is_percent ? "%" : ""), 3)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})